import { Box, Paper, Radio, InputLabel } from '@mui/material';
import React from 'react';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import GroundTransportIcon from '../../../sharedcomponents/customIcons/groundTransportIcon';
import AirTransportIcon from '../../../sharedcomponents/customIcons/airTransportIcon';
import { makeStyles } from '@mui/styles';
import { useState } from '@hookstate/core';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';

const useStyles = makeStyles({
    iconContent: {
        display: 'flex',
        justifyContent: 'center',
    },
    boxContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        padding: '8px',
    },
    iconBoxContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    radioContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

const SelectTransportation = (props) =>
{
    const classes = useStyles();
    const selectTransit = useState('air');
    const renderDialogContent = () =>
    {
        return (
            <Box className={classes.boxContent}>
                <Paper elevation={0}>
                    <Box className={classes.iconBoxContent}>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.iconContent }}
                            sx={{ height: 35 }}>
                            <AirTransportIcon
                                sx={{ transform: 'scale(2.2)' }}
                            />
                        </Paper>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.radioContent }}>
                            <Radio
                                checked={selectTransit.get() === 'air'}
                                onChange={(event) =>
                                    selectTransit.set(event.target.value)
                                }
                                value="air"
                                name="select-transit"
                            />
                            <InputLabel>Air</InputLabel>
                        </Paper>
                        {/* <FormControlLabel
                            control={<Radio />}
                            label="Air"
                            value="air"
                        /> */}
                    </Box>
                </Paper>
                <Paper elevation={0}>
                    <Box className={classes.iconBoxContent}>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.iconContent }}
                            sx={{ height: 35 }}>
                            <GroundTransportIcon
                                style={{ transform: 'scale(3.5)' }}
                            />
                        </Paper>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.radioContent }}>
                            <Radio
                                checked={selectTransit.get() === 'ground'}
                                onChange={(event) =>
                                    selectTransit.set(event.target.value)
                                }
                                value="ground"
                                name="select-transit"
                            />
                            <InputLabel>Ground</InputLabel>
                        </Paper>
                        {/* <FormControlLabel
                            control={<Radio />}
                            label="Ground"
                            value="ground"
                        /> */}
                    </Box>
                </Paper>
                {/* <Paper elevation={0}>
                    <Box className={classes.iconBoxContent}>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.iconContent }}
                            sx={{ height: 35 }}>
                            <CityTransitIcon
                                style={{ transform: 'scale(2.5)' }}
                            />
                        </Paper>
                        <Paper
                            elevation={0}
                            classes={{ root: classes.radioContent }}>
                            <Radio
                                checked={selectTransit.get() === 'citytransit'}
                                onChange={(event) =>
                                    selectTransit.set(event.target.value)
                                }
                                value="citytransit"
                                name="select-transit"
                            />
                            <InputLabel>City Transit</InputLabel>
                        </Paper>
                        <FormControlLabel
                            control={<Radio />}
                            label="City Transit"
                            value="citytransit"
                        />
                    </Box>
                </Paper> */}
            </Box>
        );
    };

    const handleClick = () =>
    {
        props.handleAction(selectTransit.get());
    };

    const renderDialogActions = () => (
        <ButtonContainer
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={'Create'}
        />
    );

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            // maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default SelectTransportation;
